module.exports = __webpack_public_path__ + "static/cwr.178bbbbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cwr.jpg
// module id = 1225
// module chunks = 65368489232520